'use strict';
import { module } from '../app';

module.directive('iframeOnload', [function () {
  return {
    scope: {
      callBack: '&iframeOnload',
      skipHiding: '='
    },
    link: function (scope, element, attrs) {
      element.on('load', function () {
        if (!scope.skipHiding) {
          let el = element;
          el.addClass('ng-hide');

          setTimeout(function () {
            el.removeClass('ng-hide');
          }, 500);
        }
        return scope.callBack();
      })
    }
  }
}]);



// WEBPACK FOOTER //
// ./src/scripts/directives/iframeOnload.js